export const AuthTrustFooter = () => {
  return (
    <div className='text-center mt-8 pt-6 border-top'>
      <p className='text-gray-700 fs-8 mb-2 d-flex flex-center'>
        <svg
          className='me-2'
          width='14'
          height='14'
          viewBox='0 0 16 16'
          fill='currentColor'
          aria-hidden='true'
        >
          <path d='M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.8 11.8 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7 7 0 0 0 1.048-.625 11.8 11.8 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.54 1.54 0 0 0-1.044-1.263 63 63 0 0 0-2.887-.87C9.843.266 8.69 0 8 0m0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5' />
        </svg>
        <span>Ambiente seguro. Seus dados são tratados conforme a LGPD.</span>
      </p>
      <div className='d-flex flex-center flex-wrap gap-2 fs-8'>
        <a
          href='https://lauduz.com/politica-de-privacidade'
          target='_blank'
          rel='noopener noreferrer'
          className='link-primary d-inline-block py-1'
        >
          Política de Privacidade
        </a>
        <span className='text-gray-700' aria-hidden='true'>
          ·
        </span>
        <a
          href='https://lauduz.com/termos-de-uso'
          target='_blank'
          rel='noopener noreferrer'
          className='link-primary d-inline-block py-1'
        >
          Termos de Uso
        </a>
      </div>
    </div>
  )
}
